export default __webpack_public_path__ + "static/media/guia-escritorio-dark-3.8731d048.png";